export default __webpack_public_path__ + "static/media/No-image.7dc847e1.jpg";